import {
  FdrDisrupter,
  FdrImage,
  FdrProductB2bInformationGroup,
  FdrProductFeatureGroup,
  FdrRequestButton,
} from '@hotelplan/supergraph-api';
import { FdrPageComponentsFragment } from 'schemas/fragment/page-components/fdr-page-components.generated';
import { FdrProductPageQuery } from 'schemas/query/product/fdr-product-page.generated';

interface IFdrPdpContent {
  hero: FdrImage;
  title: string;
  text?: string;
  leadText: string;
  disrupters: Array<FdrDisrupter>;
  bookmarked: boolean;
  pageComponents: FdrPageComponentsFragment['components'];
  routes?: Array<string>;
  featureGroups?: Array<FdrProductFeatureGroup>;
  staticRequestButton: FdrRequestButton;
  b2bInfoGroups: Array<FdrProductB2bInformationGroup>;
}

export function useFdrPdpContent(
  product: FdrProductPageQuery['fdrProduct']
): IFdrPdpContent {
  // No cruises on TH
  if (!product || product.__typename === 'FdrCruise') return null;

  const commonProps = {
    title: product.name,
    disrupters: product.disrupters,
    bookmarked: product.isInBookmarks,
    leadText: product.leadText,
    pageComponents: product.pageComponents?.components,
    staticRequestButton: product?.requestButton,
    b2bInfoGroups: product.b2bInformationGroups,
  };

  switch (product.__typename) {
    case 'FdrAdventureTravel':
      return {
        ...commonProps,
        text: product.subtitle,
        hero: product.headerImages[0],
        routes: product.route?.map(r => r.locationName) || [],
        featureGroups: product.featureGroups,
      };
    case 'FdrHotel':
      return {
        ...commonProps,
        text: `${product.resort?.destination?.name} / ${product.resort?.name}`,
        hero: product.hero,
      };
    case 'FdrRoundTrip': {
      return {
        ...commonProps,
        hero: product.hero,
        featureGroups: product.featureGroups,
      };
    }
  }
}
